import React, { Fragment } from 'react';
export const rte_error_3_9_19 = (
  <Fragment>
    <p>Refer member back to benefit provider for further assistance. Member does not have Teladoc Benefit.</p>
    <p>
      Note: If a minor, Do Not Turn Away. Follow One-Time Use account creation procedure.
    </p>
  </Fragment>
)

export const rte_error_4_5 = (
  <Fragment>
    <p>
      Create appropriate One-Time Use account. Unable to verify the member’s benefit eligibility due to a rare intermittent outage of the plan administrator’s eligibility system.
    </p>
    <p>Note: Only create if member needs a visit.</p>
  </Fragment>
)

export const rte_error_6_14 = (
  <Fragment>
    <p>
      Validate HPID entered and retry RTE. If ineligible, refer member back to benefit provider for further assistance. Currently unable to verify the information provided.
    </p>
    <p>
      Note: If a minor, Do Not Turn Away. Follow One-Time Use account creation procedure.
    </p>
  </Fragment>
)

export const rte_error_7 = (
  <Fragment>
    <p>
      Validate DOB entered and retry RTE. If ineligible, refer member back to benefit provider for further assistance. Currently unable to verify the information provided.
    </p>
    <p>
      Note: If a minor, Do Not Turn Away. Follow One-Time Use account creation procedure.
    </p>
  </Fragment>

)

export const rte_error_8_11_17_18 = (
  <Fragment>
    <p>
      Validate all information entered and retry RTE. If ineligible, refer member back to benefit provider for further assistance. Currently unable to verify the information provided.
    </p>
    <p>
      Note: If a minor, Do Not Turn Away. Follow One-Time Use account creation procedure.
    </p>
  </Fragment>
)

export const rte_error_10 = (
  <Fragment>
    <p>
      Validate Plan Code entered and retry RTE. If ineligible, refer member back
    </p>
  </Fragment>
);


export const rteErrorMap = {
  3: rte_error_3_9_19,
  4: rte_error_4_5,
  5: rte_error_4_5,
  6: rte_error_6_14,
  7: rte_error_7,
  8: rte_error_8_11_17_18,
  9: rte_error_3_9_19,
  10: rte_error_10,
  11: rte_error_8_11_17_18,
  14: rte_error_6_14,
  17: rte_error_8_11_17_18,
  18: rte_error_8_11_17_18,
  19: rte_error_3_9_19,
  undefined: 'Unable to determine eligiblity. (Unknown Error Code)'
}

export const parseServerMessage = (serverMessage) => {
  const match = /RTE Error.*#\s*(\d+).*/.exec(serverMessage)
  let errorNumber = undefined;
  if(match){
    errorNumber = parseInt(match[1]);
  }
  return rteErrorMap[errorNumber]
}
